















import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {ProresultIntegrationCompanySettings} from "../../modules/models";
import CompanyUserRequired from "../CompanyRequired";
import ContactLink from "@/components/shared/ContactLink.vue";

@Component({
  components: {
    "at-contact": ContactLink
  }
})
export default class ProresultSettingspage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    proresultSettings: ProresultIntegrationCompanySettings | null = null;
    failedCount = 0;

    get dbname() {
        return this.proresultSettings != null ? this.proresultSettings.proresultCompanyId : null;
    }

    async loadProresultSettings() {
        this.proresultSettings = await this.api.autoTmcCompanySettings(this.company.orgNum);
        this.failedCount = await this.api.autoTmcFailedCount(this.company.orgNum) || 0;
    }

    created() {
        this.baseApi.loadCompanyPromise().then(() => {
            this.loadProresultSettings();
        });
    }
}
